// extracted by mini-css-extract-plugin
module.exports = {"info-item":"index_info-item_jT-cH","label":"index_label_1Vx1A","value":"index_value_r2sx4"};